import { MarketType } from '../../../../domain/model/market-type';

export class DealerInfoModel {

  readonly licenseNumber: number;

  readonly businessName: string;

  readonly marketTypes: Set<MarketType>;

  constructor(licName: number, businessName: string, marketTypes: Set<MarketType>) {
    this.licenseNumber = licName;
    this.businessName = businessName;
    this.marketTypes = marketTypes;

  }

  static fromJSON(jsonObject: any): DealerInfoModel {
    const result = Object.create(DealerInfoModel.prototype);

    return Object.assign(result, jsonObject, {
      licenseNumber: jsonObject.licenseNumber ? Number(jsonObject.licenseNumber) : null,
      businessName: jsonObject.businessName ? String(jsonObject.businessName) : null,
      marketTypes: jsonObject.marketTypes ? new Set((jsonObject.marketTypes as any[]).map(element => MarketType.fromString(element))) : null,
    });
  }
}
